
interface ContactMethodSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const ContactMethodSelect = ({ value, onChange }: ContactMethodSelectProps) => (
  <select
    className="w-full p-2 rounded-md bg-white/5 border-white/10 text-white"
    value={value}
    onChange={(e) => onChange(e.target.value)}
  >
    <option value="email" className="bg-slate-800">Email</option>
    <option value="phone" className="bg-slate-800">Phone</option>
  </select>
);

export default ContactMethodSelect;
